import { Component, OnInit, Input } from '@angular/core';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { CollectionsService } from '../../../../services/collections.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-collections-tab',
  templateUrl: './collections-tab.component.html',
  styleUrls: ['./collections-tab.component.scss'],
})
export class CollectionsTabComponent implements OnInit {
  @Input() jobcard;
  @Input() messageService;

  public loading = false;
  public partner: any = {};
  public collectionAddrssLoading = false;
  public deliveryAddrssLoading = false;
  public allowCollection: boolean = false;
  public allowDelivery: boolean = false;
  public collected: boolean = false;
  public delivered: boolean = false;
  public partnerCoords = { lat: 0.0, lng: 0.0 };
  public collection: any = {};
  public delivery: any = {};
  public busySaving: boolean = false;
  public minDate = new Date();
  public maxDate = new Date();
  public collectionTimeSlots: any = [];
  public deliveryTimeSlots: any = [];
  public hasCollectionSlots: boolean = true;
  public hasDeliverySlots: boolean = true;
  public countryData: any = {};
  public unavailableCollectionDates: any = [];
  public unavailableDeliveryDates: any = [];
  public availableCollectionDates: any = [];
  public availableDeliveryDates: any = [];
  public addressOptions = [];
  public addressSearch: string = '';

  constructor(
    private serviceRequestService: ServiceRequestService,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private collectionsService: CollectionsService,
  ) {
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();

    this.minDate = new Date();
    this.maxDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );

    var startDate = new Date(
      moment(this.minDate).add('year', -1).format('YYYY-MM-DD'),
    );
    var endDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );
    while (startDate <= endDate) {
      var d = new Date(startDate);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      this.unavailableCollectionDates.push(d);
      this.unavailableDeliveryDates.push(d);
      startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    }

    this.getCollection();
  }

  getCollection() {
    this.loading = true;
    this.serviceRequestService.getCollectionV2(this.jobcard.ID).subscribe(
      (res) => {
        this.allowCollection = res.collection;
        this.allowDelivery = res.dropOff;
        this.collected =
          res.collectionInfo && res.collectionInfo.statusID === 10
            ? true
            : false;
        this.delivered =
          res.deliveryInfo && res.deliveryInfo.statusID === 20 ? true : false;
        this.collection = res.collectionInfo
          ? {
              scheduleDate: res.collectionInfo.scheduleDate
                ? moment(res.collectionInfo.scheduleDate).toDate()
                : null,
              fullAddress: { address: res.collectionInfo.fullAddress },
              addressDetails: {
                street_no: '',
                street_address: res.collectionInfo.addressLine2
                  ? res.collectionInfo.addressLine2.trim()
                  : null,
                city: res.collectionInfo.city,
                country: res.collectionInfo.country,
                postal_code: res.collectionInfo.postalCode,
                latitude: res.collectionInfo.latitude,
                longitude: res.collectionInfo.longitude,
              },
              postalCode: res.collectionInfo.postalCode,
              notes: res.collectionInfo.notes,
              timeSlot: {
                code: 0,
                label: res.collectionInfo.timeSlotLabel,
                deliveryVehicleID: res.collectionInfo.deliveryVehicleID,
                slotStartTime: res.collectionInfo.scheduleTimeSlotStart,
                slotEndTime: res.collectionInfo.scheduleTimeSlotEnd,
              },
            }
          : {};
        this.collectionTimeSlots = res.collectionInfo
          ? [
              {
                code: 0,
                label: res.collectionInfo.timeSlotLabel,
                deliveryVehicleID: res.collectionInfo.deliveryVehicleID,
                slotStartTime: res.collectionInfo.scheduleTimeSlotStart,
                slotEndTime: res.collectionInfo.scheduleTimeSlotEnd,
              },
            ]
          : [];

        this.delivery = res.deliveryInfo
          ? {
              scheduleDate: res.deliveryInfo.scheduleDate
                ? moment(res.deliveryInfo.scheduleDate).toDate()
                : null,
              fullAddress: { address: res.deliveryInfo.fullAddress },
              addressDetails: {
                street_no: '',
                street_address: res.deliveryInfo.addressLine2
                  ? res.deliveryInfo.addressLine2.trim()
                  : null,
                city: res.deliveryInfo.city,
                country: res.deliveryInfo.country,
                postal_code: res.deliveryInfo.postalCode,
                latitude: res.deliveryInfo.latitude,
                longitude: res.deliveryInfo.longitude,
              },
              postalCode: res.deliveryInfo.postalCode,
              notes: res.deliveryInfo.notes,
              timeSlot: {
                code: 0,
                label: res.deliveryInfo.timeSlotLabel,
                deliveryVehicleID: res.deliveryInfo.deliveryVehicleID,
                slotStartTime: res.deliveryInfo.scheduleTimeSlotStart,
                slotEndTime: res.deliveryInfo.scheduleTimeSlotEnd,
              },
            }
          : {};
        this.deliveryTimeSlots = res.deliveryInfo
          ? [
              {
                code: 0,
                label: res.deliveryInfo.timeSlotLabel,
                deliveryVehicleID: res.deliveryInfo.deliveryVehicleID,
                slotStartTime: res.deliveryInfo.scheduleTimeSlotStart,
                slotEndTime: res.deliveryInfo.scheduleTimeSlotEnd,
              },
            ]
          : [];

        this.partnerCoords = { lat: res.latitude, lng: res.longitude };
        this.loading = false;

        if (
          this.collection &&
          this.collection.fullAddress &&
          this.collection.fullAddress.address
        ) {
          this.collectionAddrssLoading = true;
          this.getLocationFromAddress(
            this.collection.fullAddress.address,
            'COLLECTION',
            false,
          );
        }
        if (
          this.delivery &&
          this.delivery.fullAddress &&
          this.delivery.fullAddress.address
        ) {
          this.deliveryAddrssLoading = true;
          this.getLocationFromAddress(
            this.delivery.fullAddress.address,
            'DELIVERY',
            false,
          );
        }
      },
      (err) => {
        this.loading = false;
      },
    );
  }

  getAvailability(
    fromDate: string,
    reset = true,
    collection = false,
    delivery = false,
  ) {
    if (
      (collection && this.collection.areaID) ||
      (delivery && this.delivery.areaID)
    ) {
      const data = {
        PartnerID: this.jobcard.PartnerID,
        FromDate: moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        ToDate: moment(fromDate)
          .add('month', 2)
          .endOf('month')
          .format('YYYY-MM-DD'),
        CurrentLocalTime: this.collection.scheduleDate && moment(this.collection.scheduleDate).toDate() < moment().toDate() ? moment(this.collection.scheduleDate).add(-7, 'day').format('YYYY-MM-DDTHH:mm:ss') : moment().format('YYYY-MM-DDTHH:mm:ss'),
        IsCollection: collection,
        IsDelivery: delivery,
        AreaID: collection
          ? this.collection.areaID
          : delivery
            ? this.delivery.areaID
            : 0,
        //"ServiceTypes": collection ? this.jobcard.Types.map(x=>{return x.TypeID}).join(",") : null
      };
      var invalidDates = JSON.parse(
        JSON.stringify(
          collection
            ? this.unavailableCollectionDates
            : delivery
              ? this.unavailableDeliveryDates
              : [],
        ),
      );
      invalidDates = invalidDates.map((x) => {
        return new Date(x);
      });
      this.collectionsService.getCollectionsAvailability(data).subscribe(
        (response: any) => {
          if (response.availableDates && response.availableDates.length > 0) {
            if (collection) {
              this.availableCollectionDates = response.availableDates;
            } else {
              this.availableDeliveryDates = response.availableDates;
            }
            response.availableDates.forEach((availableDate: any) => {
              var index = invalidDates
                .map((x) => {
                  return moment(x).format('YYYY-MM-DD');
                })
                .indexOf(
                  moment(availableDate.availableDate).format('YYYY-MM-DD'),
                );
              if (index > -1) {
                invalidDates.splice(index, 1);
              }
            });
            if (collection) {
              this.unavailableCollectionDates = invalidDates;
            } else {
              this.unavailableDeliveryDates = invalidDates;
            }

            if (!reset) {
              this.setBookingDate(
                reset,
                collection ? 'COLLECTION' : delivery ? 'DELIVERY' : '',
              );
            }
          }
          if (
            response.unavailableDates &&
            response.unavailableDates.length > 0
          ) {
            response.unavailableDates.map((x) => {
              var d = new Date(x.unavailableDate);
              d.setHours(0);
              d.setMinutes(0);
              d.setSeconds(0);
              d.setMilliseconds(0);
              var index = collection
                ? this.unavailableCollectionDates.findIndex((x) => {
                    return x.valueOf() === d.valueOf();
                  })
                : this.unavailableDeliveryDates.findIndex((x) => {
                    return x.valueOf() === d.valueOf();
                  });
              if (index === -1) {
                if (collection) {
                  this.unavailableCollectionDates.push(d);
                } else {
                  this.unavailableDeliveryDates.push(d);
                }
              }
            });
          }
          this.loading = false;
          this.collectionAddrssLoading = false;
          this.deliveryAddrssLoading = false;
        },
        (err) => {
          this.loading = false;
          this.collectionAddrssLoading = false;
          this.deliveryAddrssLoading = false;
        },
      );
    } else {
      this.loading = false;
      this.collectionAddrssLoading = false;
      this.deliveryAddrssLoading = false;
    }
  }

  updateCollection() {
    const data = {
      ServiceID: this.jobcard.ID,
      Collection: this.allowCollection,
      DropOff: this.allowDelivery,
      Collected: this.collected,
      DroppedOff: this.delivered,
      CollectionInfo:
        this.allowCollection && this.collection && this.collection.scheduleDate
          ? {
              ScheduleDate: moment(this.collection.scheduleDate).format(
                'YYYY-MM-DD',
              ),
              FullAddress: this.collection.fullAddress.address,
              AddressDetails: this.collection.addressDetails,
              TimeSlot: {
                deliveryVehicleID: this.collection.timeSlot.deliveryVehicleID,
                slotStartTime: this.collection.timeSlot.slotStartTime,
                slotEndTime: this.collection.timeSlot.slotEndTime,
              },
              Notes: this.collection.notes,
            }
          : null,
      DeliveryInfo:
        this.allowDelivery &&
        this.delivery &&
        (this.delivery.scheduleDate || !this.allowCollection)
          ? {
              ScheduleDate: this.delivery.scheduleDate
                ? moment(this.delivery.scheduleDate).format('YYYY-MM-DD')
                : null,
              FullAddress: this.delivery.fullAddress.address,
              AddressDetails: this.delivery.addressDetails,
              TimeSlot: this.delivery.timeSlot
                ? {
                    deliveryVehicleID: this.delivery.timeSlot.deliveryVehicleID,
                    slotStartTime: this.delivery.timeSlot.slotStartTime,
                    slotEndTime: this.delivery.timeSlot.slotEndTime,
                  }
                : {
                    deliveryVehicleID: 0,
                    slotStartTime: '00:00:00',
                    slotEndTime: '00:00:00',
                  },
              Notes: this.delivery.notes,
            }
          : null,
    };

    this.busySaving = true;
    this.collectionsService.updateJobCardCollectionIndo(data).subscribe(
      (res) => {
        this.busySaving = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.collections.collection_saved',
          ),
        });
      },
      (err) => {
        this.busySaving = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.collections.collection_not_saved',
          ),
        });
      },
    );
  }

  validate() {
    var collectionsValid =
      !this.allowCollection ||
      (this.allowCollection &&
        this.collection &&
        this.collection.scheduleDate &&
        this.collection.fullAddress &&
        this.collection.fullAddress.address);

    var deliveriesValid =
      !this.allowDelivery ||
      (this.allowDelivery && this.jobcard.StatusID < 40) ||
      (this.allowDelivery &&
        this.delivery &&
        this.delivery.scheduleDate &&
        this.delivery.fullAddress &&
        this.delivery.fullAddress.address &&
        this.delivery.fullAddress.address &&
        this.delivery.timeSlot);
    // this.delivery.timeSlot.deliveryVehicleID); //error on res when deliveryInfo not returned

    return collectionsValid && deliveriesValid;
  }

  selectTimeSlot(timeSlot, type) {    
    if (type === 'COLLECTION') {
      this.collection.timeSlot = timeSlot.value;
    } else {
      this.delivery.timeSlot = timeSlot.value;
    }
  }

  setBookingDate(reset = false, type) {
    if (type === 'COLLECTION') {
      if (reset) {
        this.collectionTimeSlots = [];
      }

      if (this.collection.scheduleDate) {
        if (reset) {
          this.collection.timeSlot = {};
        }

        var selectedDate = this.availableCollectionDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.collection.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.collectionTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label };
          });
          if (this.collectionTimeSlots.length == 1) {
            this.collection.timeSlot = this.collectionTimeSlots[0];

          } else if (
            this.collection &&
            this.collection.timeSlot &&
            this.collection.timeSlot.label
          ) {
            var index = this.collectionTimeSlots.findIndex((x) => {
              return x.label === this.collection.timeSlot.label;
            });
            if (index > -1) {
              this.collection.timeSlot = this.collectionTimeSlots[index];
            }
          }
        }
      }
    } else {
      if (reset) {
        this.deliveryTimeSlots = [];
      }
      if (this.delivery.scheduleDate) {
        if (reset) {
          this.delivery.timeSlot = {};
        }

        var selectedDate = this.availableDeliveryDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.delivery.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.deliveryTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label };
          });
          if (this.deliveryTimeSlots.length == 1) {
            this.delivery.timeSlot = this.deliveryTimeSlots[0];
          } else if (
            this.delivery &&
            this.delivery.timeSlot &&
            this.delivery.timeSlot.label
          ) {
            var index = this.deliveryTimeSlots.findIndex((x) => {
              return x.label === this.delivery.timeSlot.label;
            });
            if (index > -1) {
              this.delivery.timeSlot = this.deliveryTimeSlots[index];
            }
          }
        }
      }
    }
  }

  search(address, type) {
    this.addressSearch = address.query;
    if (type === 'COLLECTION') {
      this.collection.googlePlaceID = null;
      this.collectionsService
        .getAddressOptions(
          address.query,
          this.partner.Country === 'GB' && address.query.length <= 8
            ? 'GB'
            : '',
        )
        .subscribe((res) => {
          this.addressOptions = res.predictions.map((x) => {
            return { address: x.description, placeID: x.place_id };
          });
        });
    } else {
      this.delivery.googlePlaceID = null;
      this.collectionsService
        .getAddressOptions(
          address.query,
          this.partner.Country === 'GB' && address.query.length <= 8
            ? 'GB'
            : '',
        )
        .subscribe((res) => {
          this.addressOptions = res.predictions.map((x) => {
            return { address: x.description, placeID: x.place_id };
          });
        });
    }
  }

  onSelect(event, type) {
    if (type === 'COLLECTION') {
      this.collectionAddrssLoading = true;
      this.collection.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    } else {
      this.deliveryAddrssLoading = true;
      this.delivery.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    }
  }

  monthChanged(date, type) {
    if (type === 'COLLECTION') {
      this.collectionTimeSlots = [];
    } else {
      this.deliveryTimeSlots = [];
    }
    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(
      fromDate,
      false,
      type === 'COLLECTION',
      type === 'DELIVERY',
    );
  }

  async getAddressPlaceDetails(type, locationFromAddress = false) {
    if (type === 'COLLECTION') {
      await this.collectionsService
        .getAddressOptions(this.collection.fullAddress.address, `${0},${0}`)
        .subscribe((res) => {
          this.collection.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (locationFromAddress && this.collection.googlePlaceID) {
            this.getLocationFromAddress(
              this.collection.fullAddress.address,
              type,
            );
          }
        });
    } else {
      await this.collectionsService
        .getAddressOptions(this.delivery.fullAddress.address, `${0},${0}`)
        .subscribe((res) => {
          this.delivery.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (locationFromAddress && this.delivery.googlePlaceID) {
            this.getLocationFromAddress(
              this.delivery.fullAddress.address,
              type,
            );
          }
        });
    }
  }

  getLocationFromAddress(address, type, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
          (this.partner.Country === 'GB' && this.addressSearch.length <= 8
            ? ', ' + this.addressSearch + ', UK'
            : ''),
      )
      .subscribe(async (res) => {
        const data = {
          PartnerID: this.jobcard.PartnerID,
          IsCollection: type === 'COLLECTION',
          IsDelivery: type === 'DELIVERY',
          Latitude: res.lat,
          Longitude: res.lng,
          CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        };
        if (
          (type === 'COLLECTION' && !this.collection.googlePlaceID) ||
          (type === 'DELIVERY' && !this.delivery.googlePlaceID)
        ) {
          await this.getAddressPlaceDetails(type, true);
          return;
        }
        this.collectionsService.checkAddressInRange(data).subscribe(
          (addressInfo: any) => {
            if (
              addressInfo &&
              addressInfo.partnerID == this.jobcard.PartnerID
            ) {
              if (type === 'COLLECTION') {
                this.collectionsService
                  .getGooglePlaceInfo(this.collection.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.collection.addressOutOfRange = false;
                this.collection.distanceToPartner = addressInfo.distanceToStore;
                this.collection.areaID = addressInfo.areaID;
                var fromDate = moment(
                  this.collection.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, true, false);
              } else {
                this.collectionsService
                  .getGooglePlaceInfo(this.delivery.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.delivery.addressOutOfRange = false;
                this.delivery.distanceToPartner = addressInfo.distanceToStore;
                this.delivery.areaID = addressInfo.areaID;
                var fromDate = moment(
                  this.delivery.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, false, true);
              }
            } else {
              if (type === 'COLLECTION') {
                this.collection.addressOutOfRange = true;
                this.collection.distanceToPartner = -1;
                this.collection.areaID = 0;
                this.collectionAddrssLoading = false;
                this.collection.timeSlot = {};
                this.collection.scheduleDate = null;
              } else {
                this.delivery.addressOutOfRange = true;
                this.delivery.distanceToPartner = -1;
                this.delivery.areaID = 0;
                this.deliveryAddrssLoading = false;
                this.delivery.timeSlot = {};
                this.delivery.scheduleDate = null;
              }
            }
          },
          (err) => {
            if (type === 'COLLECTION') {
              this.collection.addressOutOfRange = true;
              this.collection.distanceToPartner = -1;
              this.collection.areaID = 0;
              this.collectionAddrssLoading = false;
              this.collection.timeSlot = {};
              this.collection.scheduleDate = null;
            } else {
              this.delivery.addressOutOfRange = true;
              this.delivery.distanceToPartner = -1;
              this.delivery.areaID = 0;
              this.deliveryAddrssLoading = false;
              this.delivery.timeSlot = {};
              this.delivery.scheduleDate = null;
            }
          },
        );
      });
  }

  setAddressInfo(placeInfo, type) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;
        if (type === 'COLLECTION') {
          this.collection.addressDetails = addressDetails;
          this.collection.postalCode = addressDetails.postal_code;
        } else {
          this.delivery.addressDetails = addressDetails;
          this.delivery.postalCode = addressDetails.postal_code;
        }
      }
    }
  }
}
